import React from 'react';

const CausesOne = () => {
  return (
    <section className="causes-one">
      <div className="causes-one__shape-1 float-bob-y">
        <img src="assets/images/shapes/causes-one-shape-1.png" alt="" />
      </div>
      <div className="container">
        <div className="section-title text-center sec-title-animation animation-style1">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Our Causes</span>
          </div>
          <h2 className="section-title__title title-animation">Support programs changing lives across Africa</h2>
        </div>
        <div className="causes-one__carousel owl-theme owl-carousel">
          <div className="item">
            <div className="causes-one__single">
              <div className="causes-one__arrow"><a href="donation-details.html"><span className="icon-right-arrow"></span></a></div>
              <div className="causes-one__img-box">
                <div className="causes-one__img"><img src="assets/images/Hope-Spring-Water-Charity.jpg" alt="Clean water program in Africa" /></div>
                <div className="causes-one__tag"><span>Clean Water</span></div>
              </div>
              <div className="causes-one__content">
                <h3 className="causes-one__title"><a href="donation-details.html">Safe water for families and schools</a></h3>
                <p className="causes-one__text">Wells and water filters to protect children from water‑borne illnesses.</p>
                <div className="causes-one__rised-and-progress">
                  <div className="progress-box">
                    <div className="inner count-box">
                      <div className="bar">
                        <div className="bar-inner count-bar" data-percent="86%">
                          <div className="count-text">86%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="causes-one__rised-and-goals">
                    <div className="causes-one__raised"><span>₦12,500 Raised</span></div>
                    <div className="causes-one__goals"><span>₦25,000 Goal</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="causes-one__single causes-one__single-2">
              <div className="causes-one__arrow"><a href="donation-details.html"><span className="icon-right-arrow"></span></a></div>
              <div className="causes-one__img-box">
                <div className="causes-one__img"><img src="assets/images/21.jpg" alt="Education support in Africa" /></div>
                <div className="causes-one__tag"><span>Education</span></div>
              </div>
              <div className="causes-one__content">
                <h3 className="causes-one__title"><a href="donation-details.html">Empowering futures through learning</a></h3>
                <p className="causes-one__text">Scholarships, school meals and supplies to keep children in class.</p>
                <div className="causes-one__rised-and-progress">
                  <div className="progress-box">
                    <div className="inner count-box">
                      <div className="bar">
                        <div className="bar-inner count-bar" data-percent="86%">
                          <div className="count-text">86%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="causes-one__rised-and-goals">
                    <div className="causes-one__raised"><span>₦18,200 Raised</span></div>
                    <div className="causes-one__goals"><span>₦30,000 Goal</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="causes-one__single causes-one__single-3">
              <div className="causes-one__arrow"><a href="donation-details.html"><span className="icon-right-arrow"></span></a></div>
              <div className="causes-one__img-box">
                <div className="causes-one__img"><img src="assets/images/affordable-healthcare.jpg" alt="Healthcare outreach in Africa" /></div>
                <div className="causes-one__tag"><span>Healthcare</span></div>
              </div>
              <div className="causes-one__content">
                <h3 className="causes-one__title"><a href="donation-details.html">Community health and medical aid</a></h3>
                <p className="causes-one__text">Essential medicines, maternal care and mobile clinics.</p>
                <div className="causes-one__rised-and-progress">
                  <div className="progress-box">
                    <div className="inner count-box">
                      <div className="bar">
                        <div className="bar-inner count-bar" data-percent="86%">
                          <div className="count-text">86%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="causes-one__rised-and-goals">
                    <div className="causes-one__raised"><span>₦9,750 Raised</span></div>
                    <div className="causes-one__goals"><span>₦20,000 Goal</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="causes-one__single causes-one__single-4">
              <div className="causes-one__arrow"><a href="donation-details.html"><span className="icon-right-arrow"></span></a></div>
              <div className="causes-one__img-box">
                <div className="causes-one__img"><img src="https://images.unsplash.com/photo-1527698266440-12104e498b76?auto=format&fit=crop&w=1200&q=60" alt="Nutrition support in Africa" /></div>
                <div className="causes-one__tag"><span>Nutrition</span></div>
              </div>
              <div className="causes-one__content">
                <h3 className="causes-one__title"><a href="donation-details.html">Nutritious meals for families</a></h3>
                <p className="causes-one__text">Monthly food baskets and school meals to combat hunger.</p>
                <div className="causes-one__rised-and-progress">
                  <div className="progress-box">
                    <div className="inner count-box">
                      <div className="bar">
                        <div className="bar-inner count-bar" data-percent="86%">
                          <div className="count-text">86%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="causes-one__rised-and-goals">
                    <div className="causes-one__raised"><span>₦14,300 Raised</span></div>
                    <div className="causes-one__goals"><span>₦28,000 Goal</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default CausesOne;
